import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-report-dashboard-column-chooser-dialog',
    templateUrl: './report-dashboard-column-chooser-dialog.component.html',
    // styleUrls: ['./report-dashboard-column-dialog.component.css']
})
export class ReportDashboardColumnChooserDialogComponent {
    // columnDataSource: MatTableDataSource<any>;
    columns: any[];
    constructor(
        public dialogRef: MatDialogRef<ReportDashboardColumnChooserDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any) {
        this.columns = data.columns;
        // this.columnDataSource = new MatTableDataSource<any>(this.columns || []);
    }

    onNoClick(): void {
        this.dialogRef.close();
    }
}
